import { ClientHookOptions, useVahakQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";

import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";

// services
import { QueryNames } from "@vahak/core/dist/_services/hooks/queryNames";

import API from "@vahak/core/dist/_services/const";

// types
import { ApiErrorResponseType } from "@vahak/core/dist/custom-types/api-error-response-type";
import { generateQueryString } from "@vahak/core/dist/methods/generateQueryString";

interface Params {
    loadId: number;
}

export interface LoadStopInfo {
    readonly place_id?: string;
    readonly location_id?: number;
    readonly latitude?: number;
    readonly longitude?: number;
    readonly description?: string;
    readonly address?: string;
    readonly sequence?: number;
}
export interface GetLoadDetailsResponse {
    data?: {
        stops: LoadStopInfo[];
    };
    // readonly segment_distances?: any[];
    // readonly total_distance?: number;
}

export const useGetLoadStops = (
    { loadId }: Params,
    options: ClientHookOptions<GetLoadDetailsResponse, ApiErrorResponseType>
) => {
    const { GET } = useVahakHttpClient();

    const method = () => {
        const payload = {
            id: loadId
        };
        if (payload?.id) {
            const URL = `${API.USER_LOAD_STOPS}${generateQueryString(payload)}`;
            return GET<GetLoadDetailsResponse>(URL);
        }
        return {} as GetLoadDetailsResponse;
    };

    return useVahakQuery<GetLoadDetailsResponse, ApiErrorResponseType>(
        QueryNames.userLoads.getLoadStops,
        method,
        options
    );
};
